/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type GetBackAttivitaV2IdComunicazioniIdTipoMittente =
  (typeof GetBackAttivitaV2IdComunicazioniIdTipoMittente)[keyof typeof GetBackAttivitaV2IdComunicazioniIdTipoMittente];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBackAttivitaV2IdComunicazioniIdTipoMittente = {
  RICHIEDENTE: 'RICHIEDENTE',
  TITOLARE: 'TITOLARE',
  RESPONSABILE_PROCEDIMENTO: 'RESPONSABILE_PROCEDIMENTO',
  ENDOPROCEDIMENTI_PRIMO_LIVELLO: 'ENDOPROCEDIMENTI_PRIMO_LIVELLO',
  ALTRO_UFFICIO_VARIABILE: 'ALTRO_UFFICIO_VARIABILE',
  SISTEMA: 'SISTEMA',
} as const;
